export default __webpack_public_path__ + "c2d2f8b2f2a4fc14646ebded4bdae8ea.png";